import { title } from "assets/jss/material-kit-pro-react.js";

const benefitsStyle = {
  section: {
    backgroundColor: "#111827",
    padding: "6rem 2rem",
  },
  sectionInner: {
    maxWidth: "1200px",
    margin: "0 auto",
  },
  sectionTitle: {
    ...title,
    color: "#ffffff",
    fontFamily: "'Exo 2'",
    fontWeight: 700,
    fontSize: "2.4rem",
    textAlign: "center",
    marginBottom: "0.75rem",
    "@media (max-width: 600px)": {
      fontSize: "1.8rem",
    },
  },
  sectionSubtitle: {
    color: "rgba(255,255,255,0.6)",
    fontFamily: "'Exo 2'",
    fontSize: "1.05rem",
    textAlign: "center",
    marginBottom: "4rem",
    fontWeight: 300,
    maxWidth: "640px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "1.5rem",
    "@media (max-width: 960px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 480px)": {
      gridTemplateColumns: "1fr",
    },
  },
  card: {
    backgroundColor: "rgba(255,255,255,0.04)",
    borderRadius: "14px",
    padding: "2.5rem 1.8rem",
    textAlign: "center",
    border: "1px solid rgba(255,255,255,0.08)",
    transition: "all 0.25s ease",
    "&:hover": {
      backgroundColor: "rgba(59,130,246,0.12)",
      border: "1px solid rgba(59,130,246,0.35)",
      transform: "translateY(-6px)",
    },
  },
  iconWrapper: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    backgroundColor: "rgba(59,130,246,0.15)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1.5rem auto",
  },
  icon: {
    fontSize: "2rem",
    color: "#60a5fa",
  },
  cardTitle: {
    color: "#ffffff",
    fontFamily: "'Exo 2'",
    fontWeight: 700,
    fontSize: "1.2rem",
    marginBottom: "0.9rem",
    lineHeight: 1.3,
  },
  cardDescription: {
    color: "rgba(255,255,255,0.6)",
    fontFamily: "'Exo 2'",
    fontWeight: 300,
    fontSize: "0.9rem",
    lineHeight: 1.75,
    margin: 0,
  },
};

export default benefitsStyle;
